<script lang="ts">
	import UserNavNotificationsList from './UserNavNotificationsList.svelte';
	import UserNavNotificationsStatus from './UserNavNotificationsStatus.svelte';
	import { Dropdown } from '@wiseed/wikit';
	let notificationsDropdownTriggerRef = null;
	let isNotificationsDropdownOpen = false;
</script>

<div
	class="relative"
	bind:this={notificationsDropdownTriggerRef}
	on:click={() => {
		isNotificationsDropdownOpen = !isNotificationsDropdownOpen;
	}}
>
	<UserNavNotificationsStatus />
	<Dropdown
		position="right"
		isOpen={isNotificationsDropdownOpen}
		close={() => (isNotificationsDropdownOpen = false)}
		triggerRef={notificationsDropdownTriggerRef}
		classNames="p-0"
	>
		<UserNavNotificationsList nbShown={3} />
	</Dropdown>
</div>
